<template>
    <div :class="' ' + 'relative flex flex-col ' + wrapperCssClasses">
        <label
            @click="toggle"
            :for="inputId"
            :class="'relative flex items-center gap-1 ' + labelClasses"
        >
            <input
                :id="inputId"
                :name="name"
                :ref="inputId"
                type="checkbox"
                :disabled="disabled"
                :required="required"
                class="hidden"
                :value="value"
            />

            <div
                :class="
                    (disabled
                        ? ' opacity-50 hover:cursor-not-allowed'
                        : 'hover:cursor-pointer') +
                    ($page.props.errors[name] ? ' border-red-400' : '')
                "
            >
                <svg
                    v-if="isChecked()"
                    :width="pxWidth"
                    :height="pxWidth"
                    :viewBox="'0 0' + ' ' + pxWidth + ' ' + pxWidth"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                >
                    <rect
                        :width="pxWidth"
                        :height="pxWidth"
                        rx="4"
                        :fill="checkedColors[1]"
                    />
                    <path
                        d="M6 12.05C8.12281 13.5167 11.2105 15.68 11.2105 17C12.1754 13.7 14.6842 6.88 17 6"
                        :stroke="checkedColors[0]"
                        stroke-width="1.8"
                    />
                </svg>
                <svg
                    v-else
                    :width="pxWidth"
                    :height="pxWidth"
                    :viewBox="'0 0' + ' ' + pxWidth + ' ' + pxWidth"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                >
                    <rect
                        x="0.5"
                        y="0.5"
                        :width="pxWidth - 1"
                        :height="pxWidth - 1"
                        rx="3.5"
                        :fill="uncheckedColors[1]"
                        :stroke="uncheckedColors[0]"
                    />
                </svg>
            </div>

            <div class=""></div>

            <div v-if="label" class="">
                <span v-html="label"></span>
            </div>

            <slot />
        </label>

        <div class="text-[16px] text-gray-700" v-if="hint">
            {{ hint }}
        </div>

        <div class="mt-5" v-if="$page.props.errors[name]">
            <field-error
                :field-name="label"
                :message="$page.props.errors[name]"
            />
        </div>
    </div>
</template>

<script>
import FieldError from "@/Components/FieldError";

export default {
    name: "FormCheckbox",
    components: {
        FieldError,
    },
    props: {
        id: {
            type: String,
            default: null,
        },
        label: {
            type: String,
            default: "",
        },
        hint: {
            type: String,
            default: "",
        },
        name: {
            type: String,
            default: null,
        },
        modelValue: {
            type: [String, Number, Boolean],
            default: "",
        },
        value: {
            type: [String, Number, Boolean],
            default: true,
        },
        disabled: {
            type: Boolean,
            default: false,
        },
        required: {
            type: Boolean,
            default: false,
        },
        pxWidth: {
            type: Number,
            default: 24,
        },
        checkedColors: {
            type: Array,
            default: ["#FFF", "#2475C7"],
        },
        uncheckedColors: {
            type: Array,
            default: ["#E8EBED", "transparent"],
        },
        wrapperCssClasses: {
            type: String,
            default: "",
        },
        labelClasses: {
            type: String,
            default: "text-[14px] block flex items-center",
        },
        checked: {
            type: Boolean,
            default: false,
        },
    },
    methods: {
        toggle(event) {
            event.preventDefault();
            if (!this.disabled) {
                if (this.modelValue === this.value) {
                    this.$emit("update:modelValue", null);
                } else {
                    this.$emit("update:modelValue", this.value);
                }
            }
        },
        isChecked() {
            return this.modelValue === this.value;
        },
    },
    computed: {
        inputId() {
            return this.id ?? "id_" + Math.random().toString(36).slice(2);
        },
    },
};
</script>
